import React from "react";
import LandingCategory from "../components/common/LandingCategory";
import { themes } from "../themes/themes";
import avatarMasculino from "../assets/images/carros.jpeg";
import useTrackPageView from "../hooks/useTrackPageView";
import useTimeOnPage from "../hooks/useTimeOnPage";
import { trackEvent } from "../lib/analytics";

export default function Carros() {
  useTrackPageView();
  useTimeOnPage();

  const handleWhatsappClick = async () => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "leads",
      category: "whatsapp",
      action: "click",
      label: "geral_cta_main",
    });

    await trackEvent("whatsapp_click", {
      buttonLocation: "masculino_cta_main",
    });

    window.open("https://sendwich.pro/grupos/promosclubedocarro", "_blank");
  };

  return (
    <LandingCategory
      avatar={avatarMasculino}
      titleTop="ACHADOS DE"
      titleBottom="CARROS"
      highlightWord="CARROS"
      members="10.000"
      description="Entre no grupo vip e receba todos os dias as melhoes promoções automotivas direto no seu WhatsApp 🏎️"
      whatsappLink="https://sendwich.pro/grupos/promosclubedocarro" 
      telegramLink="https://t.me/seu-link"
      theme={themes.masculino}
      onWhatsappClick={handleWhatsappClick}
    />
  );
}